module.exports = __webpack_public_path__ + "static/media/LC-weekendbag.71cbb925.png";